import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Paper, IconButton, Icon } from '@mui/material';
import { Search} from '@mui/icons-material';

const Searchbar = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if(searchTerm) {
      navigate(`/search/${searchTerm}`);

      setSearchTerm('');
    }
  }

  return (
    <Paper 
    component="form"
    onSubmit={handleSubmit}
    sx={{
        borderRadius: 20,
        border: '1px solide #e3e3e3',
        pl: 2,
        boxShadow: 'none',
        mr: { sm: 5 },
        backgroundColor: '#1F1F23'
    }}
    >
        <input 
            className='search-bar'
            placeholder='Search...'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ backgroundColor: '#1F1F23', color: 'white' }}
        />
        <IconButton type="submit" sx={{ p:'10px', color: '#1D92FF' }}>
            <Search />
        </IconButton>
    </Paper>
  )
}

export default Searchbar